/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';
import TokenDecoder from 'src/helpers/TokenDecoder';

export default {
    GetProductDetails,
    GetProductDetailsByProductID,
    SaveProduct,
    UpdateProduct,
    GetProductCategoties,
    GetProductTypes,
    GetProductCategotiesForDropDown,
    GetAllProductVarietyByProductID,
    DeleteProductVariety,
    DeleteProductBOM,
    GetSpecialProductCategotiesForDropDown,
    CheckProductPlotAvailablility,
    GetProductSubCategotiesForDropDown,
    GetAllProductsForBOMDropDown
};

async function GetProductCategoties() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetails', null);
    return response.data;
}

async function GetProductTypes() {
    const response = await CommonGet('/api/ProductType/GetAllProductTypes', null);
    return response.data;
}

async function GetProductDetails(productcatogeryID) {
    const response = await CommonGet('/api/Product/GetAllProducts', 'productcatogeryID=' + parseInt(productcatogeryID));
    return response;

}

async function GetProductDetailsByProductID(productID) {
    const response = await CommonGet('/api/Product/getProductDetailsByID', 'productID=' + parseInt(productID));
    return response.data;

}

async function GetProductCategotiesForDropDown() {
    const response = await CommonGet('/api/ProductCategory/GetProductCategoryDetailsForDropDown', null);
    return response.data;
}

async function GetProductSubCategotiesForDropDown() {
    const response = await CommonGet('/api/ProductSubCategory/GetProductSubCategoryDetails', null);
    return response.data;
}

async function GetSpecialProductCategotiesForDropDown() {
    const response = await CommonGet('/api/SpecialProductCategory/GetSpecialProductCategoryDetailsForDropDown', null);
    return response.data;
}

async function GetAllProductsForBOMDropDown(excludeProductID = null) {
    const response = await CommonGet('/api/Product/GetAllProductsDetails', null);
    const data = response?.data ?? [];

    const excludeId = excludeProductID === null || excludeProductID === undefined || excludeProductID === ''
        ? null
        : Number(excludeProductID);

    if (!excludeId) {
        return data;
    }

    return data.filter((x) => {
        const id = Number(x?.productID ?? x?.ProductID ?? x?.productId ?? x?.id ?? 0);
        return id !== excludeId;
    });
}

async function SaveProduct(values, image, productVariety, productSubCategoryID, isBOMEnabled = false, bomLines = [], isCutSKUEnabled = false) {

    var formdata = {
        ProductCategoryID: parseInt(values.productCategoryID),
        ProductSubCategoryID: productSubCategoryID,
        SpecialProductCategoryID: parseInt(values.specialProductCategoryID),
        ProductCode: values.productCode,
        ProductName: values.productName,
        ProductDescription: values.productDescription,
        OffValue: parseInt(values.offValueTypeID) == 0 ? parseFloat(0) : values.offValue == "" ? parseFloat(0) : parseFloat(values.offValue),
        OffValueTypeID: parseInt(values.offValueTypeID),
        MeasuringUnit: parseInt(values.measuringUnitID),
        MeasuringGram: parseInt(values.measuringUnitID) == 1 ? values.measuringGram == "" ? parseFloat(0) : parseFloat(values.measuringGram) : parseFloat(0),
        IsActive: values.isActive,
        IsSeasonal: values.isSeasonal,
        CreatedBy: parseInt(TokenDecoder.getUserIDFromToken()),
        CreatedDate: new Date(),
        Image: image,
        ProductVarieties: productVariety,
        IsBOMEnabled: isBOMEnabled,
        IsCutSKUEnabled: isCutSKUEnabled,
        BillOfMaterials: bomLines
    }
    const response = await CommonPost('/api/Product/SaveProduct', null, formdata);
    return response;
}

async function UpdateProduct(values, image, productVarietyForUpdate, productID, productVariety, productSubCategoryID, isBOMEnabled = false, bomLines = [], isCutSKUEnabled = false, deletedBomMappingIDs = []) {

    var formdata = {
        ProductID: parseInt(productID),
        ProductCategoryID: parseInt(values.productCategoryID),
        productSubCategoryID: productSubCategoryID,
        SpecialProductCategoryID: parseInt(values.specialProductCategoryID),
        ProductCode: values.productCode,
        ProductName: values.productName,
        ProductDescription: values.productDescription,
        OffValue: parseInt(values.offValueTypeID) == 0 ? parseFloat(0) : values.offValue == "" ? parseFloat(0) : parseFloat(values.offValue),
        OffValueTypeID: parseInt(values.offValueTypeID),
        MeasuringUnit: parseInt(values.measuringUnitID),
        MeasuringGram: parseInt(values.measuringUnitID) == 1 ? values.measuringGram == "" ? parseFloat(0) : parseFloat(values.measuringGram) : parseFloat(0),
        IsActive: values.isActive,
        IsSeasonal: values.isSeasonal,
        ModifiedBy: parseInt(TokenDecoder.getUserIDFromToken()),
        ModifiedDate: new Date(),
        Image: image,
        ProductVarieties: productVarietyForUpdate,
        IsBOMEnabled: isBOMEnabled,
        IsCutSKUEnabled: isCutSKUEnabled,
        BillOfMaterials: bomLines,
        DeletedBOMMappingIDs: (deletedBomMappingIDs || []).map((x) => parseInt(x)).filter((x) => x > 0)
    }
    const response = await CommonPost('/api/Product/UpdateProduct', null, formdata);
    return response;
}

async function GetAllProductVarietyByProductID(productID) {
    const response = await CommonGet('/api/Product/GetAllProductVarietyByProductID', 'productID=' + parseInt(productID));
    return response.data;
}

async function DeleteProductVariety(productVarietyID, isBOMEnabled = false, isCutSKUEnabled = false) {
    const bomEnabled = Boolean(isBOMEnabled);
    const cutEnabled = Boolean(isCutSKUEnabled);
    const response = await CommonGet(
        '/api/Product/DeleteProductVariety',
        'productVarietyID=' + parseInt(productVarietyID) + '&isBOMEnabled=' + bomEnabled + '&isCutSKUEnabled=' + cutEnabled
    );
    return response.data;
}

async function DeleteProductBOM(productBomMappingID) {
    const response = await CommonGet('/api/Product/DeleteProductBOM', 'productBomMappingID=' + parseInt(productBomMappingID));
    return response.data;
}

async function CheckProductPlotAvailablility(productVarietyID) {
    const response = await CommonGet('/api/Product/CheckProductPlotAvailablility', 'productVarietyID=' + parseInt(productVarietyID));
    return response.data;
}